import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'action-notifications',
});

export const actionRouteRef = createRouteRef({
  id: 'action-notifications:action',
  params: ['actionId'],
});

export const testNotificationRouteRef = createRouteRef({
  id: 'action-notifications:test',
});
